import { render, staticRenderFns } from "./PropositionOptionForm.vue?vue&type=template&id=111486b8"
import script from "./PropositionOptionForm.vue?vue&type=script&lang=ts"
export * from "./PropositionOptionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports